"use client";

import Link from "next/link";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-center space-y-6 p-8">
        <div className="space-y-2">
          <h1 className="text-6xl font-bold text-gray-900 dark:text-gray-100">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300">
            Page Not Found
          </h2>
        </div>

        <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
          Sorry, we couldn&apos;t find the page you&apos;re looking for. The page might have been
          moved, deleted, or doesn&apos;t exist.
        </p>

        <div className="flex gap-4 justify-center">
          <Link
            href="/"
            className="rounded-full transition-colors flex items-center justify-center bg-blue text-background gap-2 hover:bg-[#383838] dark:hover:bg-[#ccc] font-medium text-sm h-10 px-5"
          >
            Go Home
          </Link>

          <button
            onClick={() => window.history.back()}
            type="button"
            className="rounded-full cursor-pointer border border-solid border-black/[.08] dark:border-white/[.145] transition-colors flex items-center justify-center hover:bg-blue/40 dark:hover:bg-[#1a1a1a] hover:border-transparent font-medium text-sm h-10 px-5"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
